import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/envioNotificaciones';
import EmailList from './Emails';


const ms2p = (state) => {
  return {
    ...state.emailsbysendsReducer,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(EmailList);
